import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton';


const styles = theme => ({
    button: {
        // margin: theme.spacing.unit,
        outline: 'none !important',
    },
});


class StructureVisibilityButton extends React.Component {

    static propTypes = {
        component: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            show: true,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = () => {
        this.setState(prevState => ({
                show: !prevState.show
            }),
            () => {
                this.props.component.setVisibility(this.state.show)
            }
        );
    };

    render() {
        const {classes} = this.props;

        return (

            <IconButton edge='start' color="primary" className={classes.button}
                        aria-label="Visibility"
                        onClick={this.handleClick}
            >{this.state.show ? (
                <VisibilityIcon fontSize="small"/>
            ) : (
                <VisibilityOffIcon fontSize="small"/>
            )}
            </IconButton>

        );
    }
}

export default withStyles(styles)(StructureVisibilityButton);